import _defineProperty from "/runner/_work/miro-site/miro-site/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/runner/_work/miro-site/miro-site/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["title", "description", "preview", "href", "slug", "onSelectTemplate"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import React from 'react';
import styled from 'styled-components';
import { jsx as _jsx } from "react/jsx-runtime";
var SearchResultLink = styled.a.withConfig({
  displayName: "SearchResultItem__SearchResultLink",
  componentId: "sc-1xfoiz6-0"
})(["display:block;color:var(--wcds-colors-indigo-90);cursor:pointer;", " ", ""], function (_ref) {
  var theme = _ref.theme;
  return theme.normalizeStyles({
    paddingTop: 12,
    paddingBottom: 12,
    paddingLeft: 16,
    paddingRight: 16,
    borderRadius: 4,
    fontSize: 16,
    lineHeight: 20
  });
}, function (_ref2) {
  var theme = _ref2.theme,
      isActive = _ref2.isActive;
  return isActive && theme.normalizeStyles({
    backgroundColor: [null, 'var(--wcds-colors-blue-10)', 'var(--wcds-colors-blue-10)', 'var(--wcds-colors-blue-10)']
  });
});

var SearchResultItem = function SearchResultItem(_ref3) {
  var title = _ref3.title,
      description = _ref3.description,
      preview = _ref3.preview,
      href = _ref3.href,
      slug = _ref3.slug,
      onSelectTemplate = _ref3.onSelectTemplate,
      props = _objectWithoutProperties(_ref3, _excluded);

  return /*#__PURE__*/_jsx(SearchResultLink, _objectSpread(_objectSpread({
    href: href,
    onClick: function onClick(e) {
      if (onSelectTemplate) {
        e.preventDefault();
        onSelectTemplate({
          title: title,
          description: description,
          preview: preview,
          href: href,
          slug: slug
        });
      }
    }
  }, props), {}, {
    children: title
  }));
};

export default SearchResultItem;